module.exports = __webpack_public_path__ + "fonts/iconfont.327bd62b.woff";